import React, { Component } from "react";
import BrowserHistoryDispatcher from "dispatchers/browser-history-dispatcher";
import MessageRowItemContainer from "./messaging-row-item-container";
import MessageThread from "./messaging-thread";

export default class InviteItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preview: true,
    };
    this.togglePreview = this.togglePreview.bind(this);
    this.redirectToInbox = this.redirectToInbox.bind(this);
  }

  togglePreview() {
    this.props.onclick(this.props.message.id);
  }

  redirectToInbox() {
    BrowserHistoryDispatcher.push(`/messaging/inbox/${this.props.message.conversation_id}`);
  }

  render() {
    const { message, logo, brandName, userName, text, timestamp, status } = this.props;
    const noToggle =
      message.messageType == "sentApplication" || message.messageType == "sentInvitation";

    if (this.props.preview) {
      return (
        <MessageRowItemContainer
          logo={logo}
          brandName={brandName}
          userName={userName}
          heading={message.heading}
          text={text}
          timestamp={timestamp}
          clickFunction={noToggle ? this.redirectToInbox : this.togglePreview}
          status={status}
          highlight={message.highlight}
        />
      );
    } else {
      return (
        <MessageThread
          messages={[message]}
          collapse={this.togglePreview}
          hideResponse={true}
          showCollapseInThread={true}
        />
      );
    }
  }
}
